import PropTypes from 'prop-types';
import React from 'react';

function HappyTooth({ height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 379.4 415.93"
      height={height}
      width={width}
      role="presentation"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            fill="#efece1"
            d="M188.56,288.22c46.51,0,24.89,127.71,60.26,127.71,79.24-2,73.65-133.29,93-164.38,25.13-40.38,68.57-184.46,3.28-231.18-61.57-44-123.12,0-156.4,0s-97-45.83-156.4,0c-59.92,46.27-23,191.52,3.28,231.18,20.2,30.55,13.76,162.41,93,164.38,35.37,0,13.75-127.71,60.25-127.71"
          />
          <path
            className="cls-2"
            fill="#fff"
            d="M68.4,17.16C20.14,34.49,9.72,134.8,64.61,199.83c56.75,67.22,194,63.3,251.89,5.67,36.31-36.17,61-144.27-3-179.45-52.19-28.67-79.46,7.86-124,7S118.38-.78,68.4,17.16Z"
          />
          <path
            fill="#fff"
            className="cls-2"
            d="M114.07,301.1c-38.56,0-10.54,75.27,9.51,74.31S143.3,301.1,114.07,301.1Z"
          />
          <path
            fill="#fff"
            className="cls-2"
            d="M263.69,309.83c32.05,0,20.08,70.77-9.61,70.74C238.27,380.55,240.1,309.84,263.69,309.83Z"
          />
          <path
            className="cls-3"
            fill="#541300"
            d="M85.62,120.26c-6.67-5.63,3.25-33.35,29.79-33.35s36,27.34,30.44,33.35c-4.77,5.2-10.62-16.11-29.79-16.11S91.25,125,85.62,120.26Z"
          />
          <path
            className="cls-3"
            fill="#541300"
            d="M232.65,120.26c-6.67-5.63,3.25-33.35,29.79-33.35s35.95,27.34,30.44,33.35c-4.77,5.2-10.62-16.11-29.79-16.11S238.28,125,232.65,120.26Z"
          />
          <path
            className="cls-4"
            fill="#ffc0d7"
            d="M308.24,143.27c2.29,10.87-7.28,22.1-21.37,25.06S259.5,164.88,257.22,154s7.27-22.1,21.36-25.06S306,132.4,308.24,143.27Z"
          />
          <path
            className="cls-4"
            fill="#ffc0d7"
            d="M69.32,143.27c-2.28,10.87,7.28,22.1,21.37,25.06s27.37-3.45,29.66-14.32S113.07,131.91,99,129,71.61,132.4,69.32,143.27Z"
          />
          <path
            className="cls-3"
            fill="#541300"
            d="M233,168.26c7.5-9.3-3.34-16.48-10.46-7.84-10.78,13.07-53.55,12-64.53,0-7.55-8.27-17.25-2-10.46,7.84C161,187.74,214.67,191,233,168.26Z"
          />
        </g>
      </g>
    </svg>
  );
}

HappyTooth.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default HappyTooth;
